// User-facing copy: account. Moved from the web app (components/AvatarPicker.tsx, components/Emails.tsx, components/LibraryCard.tsx, components/Profile.tsx, pages/Me.tsx, pages/Settings.tsx, pages/SharedCard.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/AvatarPicker.tsx */
export const avatarPicker = {
    changeYourPicture: "Change your picture",
    profilePicture: "Profile picture",
    selectAnImage: "Select an image",
    close: "Close",
    uploading: "Uploading…",
    uploadAPhoto: "Upload a photo",
    croppedSquareAndShrunk: "Cropped square and shrunk on your device.",
    fromYourSignIns: "From your sign-ins",
    looking: "Looking…",
    thePictureEachOne: "The picture each one has for you right now.",
    useYourPicture: (x) => `Use your ${x} picture`,
    removeYourPhoto: (x) => `Remove your photo${x}`,
    andUseYourPicture: (x) => ` and use your ${x} picture`,
};
/** components/Emails.tsx */
export const emails = {
    fromGoogle: "From Google",
    fromDiscord: "From Discord",
    fromApple: "From Apple",
    fromASignIn: "From a sign-in code",
    addedByYou: "Added by you",
    enterTheCodeWe: "Enter the code we sent to ",
    sendItAgain: "Send it again",
    sendEmailsTo: "Send emails to",
    hiddenByApple: "Hidden by Apple",
    weCouldnTDeliver: "we couldn't deliver to it",
    notConfirmed: "not confirmed",
    confirmIt: "Confirm it",
    choosingAConfirmedAddress: "Choosing a confirmed address takes effect straight away.",
    appleForwardsTheseTo: "Apple forwards these to your real inbox. You can use another address instead.",
    useADifferentAddress: "Use a different address",
    addAnAddress: "Add an address",
    sending: "Sending…",
    sendItACode: "Send it a code",
    nothingElseGoesThere: (x) => `Nothing else goes there until you confirm it.${x}`,
    untilThenEmailsKeep: (address) => ` Until then, emails keep going to ${address}.`,
    yourEmailAddresses: "Your email addresses",
    onlyConfirmedOnesCan: "Only confirmed ones can sign in or get email.",
    weCouldnTDeliver2: "We couldn't deliver to it",
    confirmed: "Confirmed",
    notConfirmed2: "Not confirmed",
    getsNotifications: "Gets notifications",
    remove: "remove",
    removeYouWonT: (address) => `Remove ${address}? You won't be able to sign in with this address any more.`,
    remove2: "Remove",
    keep: "Keep",
    newAddress: "New address",
    cancel: "Cancel",
};
/** components/LibraryCard.tsx */
export const libraryCard = {
    jan: "JAN",
    feb: "FEB",
    mar: "MAR",
    apr: "APR",
    may: "MAY",
    jun: "JUN",
    jul: "JUL",
    aug: "AUG",
    sep: "SEP",
    oct: "OCT",
    nov: "NOV",
    dec: "DEC",
    star: "star",
    stars: "stars",
    returnedUnfinished: (title, longDate) => `${title}, returned unfinished ${longDate}`,
    readIn: (title, getFullYear, stars) => `${title}, read in ${getFullYear}${stars}`,
    finished: (title, longDate, stars) => `${title}, finished ${longDate}${stars}`,
    pagemates: "Pagemates",
    no: (no) => `No. ${no}`,
    reader: "Reader",
    issued: (toUpperCase) => `Issued ${toUpperCase}`,
    sLibraryCardNo: (name, no, length, x) => `${name}'s library card, No. ${no}, ${length} ${x}`,
    book: "book",
    books: "books",
    date: "Date",
    title: "Title",
    returned: "Returned",
    cardNoIsFull: (last, x) => `Card No. ${last} is full. Here's No. ${x}.`,
    backToCardNo: (x) => `Back to card No. ${x}`,
    earlierCards: "Earlier cards",
    cardNo: (x) => `Card No. ${x}`,
    earlier: (count, x) => `${count} earlier ${x}`,
    card: "card",
    cards: "cards",
    hide: (label) => `Hide ${label}`,
    show: (label) => `Show ${label}`,
};
/** components/Profile.tsx */
export const profile = {
    cardIssued: (monthYear) => `Card issued ${monthYear}`,
    hardcover: "Hardcover",
    keepsTheirCardTo: "Keeps their card to themselves.",
    readingNow: "Reading now",
    andMore: (hidden) => `and ${hidden} more`,
    book: "book",
    books: "books",
    aQuoteFrom: "A quote from ",
    readPastToSee: (x) => `. Read past ${x} to see it.`,
    p: (pageAt) => `p. ${pageAt}`,
    save: "Save",
    cancel: "Cancel",
    nameShownInClubs: "Name shown in clubs",
    editYourName: "Edit your name",
    oneLineAboutYou: "One line about you",
    slowReaderFastTalker: "Slow reader, fast talker.",
    addALineAbout: "Add a line about you",
    editTheLineAbout: "Edit the line about you",
    favouriteGenres: "Favourite genres",
    upTo: (MAX_CLUB_GENRES) => `up to ${MAX_CLUB_GENRES}`,
    editFavouriteGenres: "Edit favourite genres",
    pinnedQuote: "Pinned quote",
    chooseAQuoteTo: "Choose a quote to pin",
    pinAQuoteYou: "Pin a quote you posted in Talk or saved in your notes.",
    yourNotes: "your notes",
    noQuotesYetPost: "No quotes yet. Post one in Talk, or save one in your notes on a book.",
    unpin: "Unpin",
    returnedUnfinished: (longDate) => `Returned unfinished ${longDate}`,
    readIn: (getFullYear) => `Read in ${getFullYear}`,
    finished: (longDate) => `Finished ${longDate}`,
    close: "Close",
    pages: (pages) => ` · ${pages} pages`,
    sRating: (ownerName) => `${ownerName}'s rating`,
    sCard: (name) => `${name}'s card`,
    profile: "Profile",
    settings: "Settings",
    thisProfileIsnT: "This profile isn't available",
    itMayBePrivate: "It may be private.",
    clubs: (size) => `${size} clubs`,
};
/** pages/Me.tsx */
export const me = {
    back: "Back",
    settings: "Settings",
};
/** pages/Settings.tsx */
export const settings = {
    appearance: "Appearance",
    thisBrowserOnlySystem: "This browser only. System follows your device.",
    system: "System",
    dark: "Dark",
    light: "Light",
    hardcover: "Hardcover",
    connected: "connected",
    needsReconnect: "needs reconnect",
    connectedYourProgressWill: "Connected. Your progress will sync from Hardcover from now on.",
    youCancelledOnHardcover: "You cancelled on Hardcover's side. Nothing was connected.",
    thatDidnTGo: "That didn't go through. Try connecting again.",
    connectYourHardcoverAccount: "Connect your Hardcover account and your reading progress on club books syncs on its own. Pagemates only asks to read your library.",
    connectHardcover: "Connect Hardcover",
    linkedAs: "Linked as ",
    hardcoverStoppedAcceptingOur: "Hardcover stopped accepting our access, so syncing has paused.",
    lastSynced: (toLocaleString) => `Last synced ${toLocaleString}.`,
    notSyncedYet: "Not synced yet.",
    reconnect: "Reconnect",
    syncing: "Syncing…",
    syncNow: "Sync now",
    disconnect: "Disconnect",
    disconnectHardcoverProgressAlready: "Disconnect Hardcover? Progress already synced stays; nothing new comes in until you reconnect.",
    syncedUpdate: (updated, x) => `Synced. ${updated} update${x}.`,
    s: "s",
    nothingToSyncRight: "Nothing to sync right now.",
    sharedClubs: "Shared clubs",
    peopleInAClub: "People in a club with you.",
    onlyMe: "Only me",
    clubmatesSeeYourName: "Clubmates see your name, photo and what you're reading together.",
    anyoneWithTheLink: "Anyone with the link",
    clubmatesAndAnyoneYou: "Clubmates, and anyone you send your card's link to.",
    whoCanSeeYour: "Who can see your card",
    yourNameAndPhoto: "Your name and photo always show in clubs you're in.",
    visibility: "Visibility",
    confirm: "Confirm",
    letAnyoneWithThe: "Let anyone with the link see your card?",
    anyoneYouSendIt: "Anyone you send it to, signed in or not, will see:",
    yourNamePhotoLine: "Your name, photo, line about you and genres",
    whenYourCardWas: "When your card was issued, and your Hardcover link",
    yourPinnedQuoteSealed: "Your pinned quote, sealed until they've read past it",
    yourStampsComeFrom: "Your stamps come from your clubs, and someone with the link isn't in them, so ",
    yourCardWillLook: "your card will look empty to them",
    unlessYouShowBooks: " unless you show books from other clubs.",
    showMyStamps: "Show my stamps",
    withoutClubNames: "Without club names.",
    showMyStampsTo: "Show my stamps to people with the link",
    neverShownWhichClubs: "Never shown: which clubs you're in, or what you're reading now.",
    cancel: "Cancel",
    turnOn: "Turn on",
    yourCardSLink: "Your card's link",
    copied: "Copied",
    copyLink: "Copy link",
    booksFromOtherClubs: "Books from other clubs",
    stampsFromClubsThe: "Stamps from clubs the person looking isn't in. Your own card always shows everything.",
    stamps: "Stamps",
    hidden: "Hidden",
    shownWithoutClubNames: "Shown without club names",
    clubmatesSeeUpTo: "Clubmates see up to ",
    stampsNotJustThe: " stamps, not just the ",
    fromClubsYouRe: " from clubs you're in.",
    clubmatesWillSeeUp: "Clubmates will see up to ",
    stampsInsteadOf: " stamps instead of ",
    yourCard: "Your card",
    settings: "Settings",
    account: "Account",
    howYouSignIn: "How you sign in, Hardcover, and how the app looks on this browser.",
    signOut: "Sign out",
    deleteMyAccount: "Delete my account",
    thisRemovesYourProgress: "This removes your progress, comments, ratings and your library card from every club. Clubs you own go to their longest-standing admin or member. There is no undo.",
    policyAndContact: "Policy and contact",
};
/** pages/SharedCard.tsx */
export const sharedCard = {
    pagemates: "Pagemates",
    thisProfileIsnT: "This profile isn't available",
    goToYourClubs: "Go to your clubs",
    whatIsPagemates: "What is Pagemates?",
    itMayBePrivate: "It may be private, or the link is wrong.",
};
//# sourceMappingURL=account.js.map